import React from 'react';

import './skeleton.style.scss';

export default function Skeleton({ width, height, margin }) {
  return <div className="skeleton-block" style={{ width, height, margin }} />;
}
